/**
 * The identity-signed retail build (DWLF-403). `REACT_APP_AUTH_MODE=identity` at build time makes
 * this the app at next.dwlf.co.uk: the person signs in to dwlf-identity as well as to SPT, and the
 * engine reads dwlf-retail-api exposes go there with the identity token. Every other call (account
 * data) still goes to SPT with the SPT session, until phase 3 moves each domain into
 * dwlf-retail-api. Any other value, or none, is the legacy build at dwlf.co.uk, unchanged.
 */
export const IS_IDENTITY_BUILD = process.env.REACT_APP_AUTH_MODE === 'identity';

export const IDENTITY_URL = 'https://id.dwlf.co.uk';
/** The identity product id: the audience of this app's tokens. */
export const IDENTITY_PRODUCT = 'retail';
export const RETAIL_API_URL = 'https://api.retail.dwlf.co.uk/v1';
/**
 * The retail product's own Google client. Never the legacy client in ./auth.js: identity checks
 * the ID token's audience against this one, so a token minted on the legacy app cannot start an
 * identity session. Its only authorised origin is https://next.dwlf.co.uk.
 */
export const RETAIL_GOOGLE_CLIENT_ID = '178635765634-kk79t6iboo8utid9hifv9grfj8uk41c7.apps.googleusercontent.com';
